import Requests from './';
import RequestAll from './RequestAll';
import NewBooking from '../../components/Booking/NewBooking';

const routesRequests = [
  {
    path: '/requests',
    component: Requests,
  },
  {
    path: '/requests/all',
    component: RequestAll,
  },
  {
    path: '/requests/new',
    component: NewBooking,
  },
];

export default routesRequests;
